import React from 'react';
import {classes, style} from './doppe-bymo-page-media-view.st.css';
import {DoppePageMediaView} from "../doppe-page-media-view/doppe-page-media-view";
import {OmitStrict, PickKeys} from "@wix/devzai-utils-common";
import {
    BymoPageMedia,
    bymoPageMediaIsBymoPageWixVideoResource,
    bymoPageMediaIsEmbeddedVideoPlayer
} from "../../client-server-common";
import {DoppeViewerVideoPlayer} from "../doppe-viewer-video-player/doppe-viewer-video-player";
import {EmbeddedVideoPlayer} from "@wix/devzai-utils-react";

export const DoppeBymoPageMediaView = React.memo(function DoppeBymoPageMediaView (props: DoppeBymoPageMediaView.Props) {
    const {
        mediaResource,

        className,
        ...restProps
    } = props;

    if (mediaResource && bymoPageMediaIsBymoPageWixVideoResource(mediaResource) && mediaResource.renderAsPlayer) {
        return (
            <DoppeViewerVideoPlayer
                className={style(classes.root, className)}
                videoResource={mediaResource}
                muteVideo={false}
                autoplay={mediaResource.playerAutoPlay ?? false}
            />
        )
    }

    if (mediaResource && bymoPageMediaIsEmbeddedVideoPlayer(mediaResource)) {
        return (
            <EmbeddedVideoPlayer
                className={style(classes.root, className)}
                autoplay={mediaResource.playerAutoPlay ?? false}
                videoUrl={mediaResource.externalVideoUrl}
                muteVideo={false}
                widthHeightRatio={16/9}
            />
        )
    }

    return (
        <DoppePageMediaView
            {...restProps}
            className={style(classes.root, className)}
            mediaResource={mediaResource}
        />
    );
});

export namespace DoppeBymoPageMediaView {

    export type OmittedProps = PickKeys<DoppePageMediaView.Props, 'mediaResource'>

    export interface Props extends OmitStrict<DoppePageMediaView.Props, OmittedProps | 'mediaResource'> {
        mediaResource: BymoPageMedia | null;
    }
}
